import {
  isQuotePageVariant,
  PersonalisedQuoteVariant,
  QuotePageVariant,
} from '@domgen/shared/enums/featureFlags';
import { store } from '../../store/store';
import { QuotePageA } from './QuotePageA/QuotePageA';
import { QuotePagePersonalised } from './QuotePagePersonalised/QuotePagePersonalised';
import { QuotePageRadio } from './QuotePageRadio/QuotePageRadio';

/**
 * Picks the quote page layout from the experiments recorded on the quote (see setQuote).
 *
 * The personalised quote test wins when it says `personalised`; otherwise the v2 experiment
 * decides, so the personalised test's control is always the current default page.
 */
export function QuotePage() {
  const { quote, gaEventData } = store.get().context;
  const experiments = quote?.experiments;

  // Sessions saved before `quote.experiments` existed only carry the v2 variant in GA data.
  // Only an absent `experiments` triggers this, never an empty object. Remove once v2 ends.
  const legacyV2Variant = isQuotePageVariant(gaEventData?.experimentVariant)
    ? gaEventData.experimentVariant
    : undefined;
  const quotePageV2 = experiments ? experiments.quotePageV2 : legacyV2Variant;

  if (experiments?.personalisedQuote === PersonalisedQuoteVariant.PERSONALISED) {
    return <QuotePagePersonalised />;
  }

  if (quotePageV2 === QuotePageVariant.RADIO) {
    return <QuotePageRadio />;
  }

  return <QuotePageA />;
}
